export enum LandlordCustomerSize {
  PRIVATE = 'PRIVATE',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  ENTERPRISE = 'ENTERPRISE'
}
